
var Model = require("../types/Model.js");

var is4XX = /4\.\d+\.\d+/;
var is3XX = /3\.\d+\.\d+/;

module.exports = new Model({
	name: "keyboard",

	init: init,
	uninit: uninit,
	triggers: triggers,
	listeners: listeners
});

function triggers(){
	return {
		"open": keyboardShown,
		"close": keyboardHide
	};
}

function listeners(){
	return {
		"machinetracker:updated": handle_machinetracker_update
	};
}

function init() {
	this._apkVersion = null;
	this.push(false);
}

function uninit() {
	this._apkVersion = null;
}

function keyboardShown(){
	var apk = this._apkVersion;

	if(!apk) return;
	if (!apk.match(is4XX) || apk.match(is3XX)) return;

	if(!this.data)
		this.push(true);
}

function keyboardHide(){
	if(this.data)
		this.push(false);
}

function handle_machinetracker_update(data){
	this._apkVersion = data.apk;
}
